<div class="session_wrapper_2 signup-2 login-2">
  <div class="session_wrapper_2-left_container">
    <div class="behamics-logo">
      <img src="../../../assets/img/behamics_logo.svg" alt="Behamics" />
    </div>

    <!-- Login -->
    <form
      class="session_wrapper_2-content"
      [formGroup]="loginForm"
      (ngSubmit)="login()"
      *ngIf="view === 'login'"
    >
      <div class="session_wrapper_2-header">
        <img
          class="am-product-logo"
          src="../../../assets/img/agentic_monitoring_logo.svg"
          alt=""
        />
        <div class="session_wrapper_2-header-text">
          <h1>Sign in to Agentic Monitoring</h1>
        </div>
      </div>
      <div class="session_wrapper_2-body">
        <button
          type="button"
          class="login-with_email-button"
          mat-button
          [disabled]="loading"
          (click)="loginWithGoogle($event)"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100"
            height="100"
            viewBox="0 0 48 48"
            aria-hidden="true"
          >
            <path
              fill="#FFC107"
              d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"
            ></path>
            <path
              fill="#FF3D00"
              d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"
            ></path>
            <path
              fill="#4CAF50"
              d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"
            ></path>
            <path
              fill="#1976D2"
              d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"
            ></path>
          </svg>
          <span>Continue with Google</span>
        </button>
        <div class="session_wrapper_2-body-or"><p>or</p></div>
        <div class="session_wrapper_2-body-inputs-container show-inputs">
          <div class="session_wrapper_2-input">
            <label for="am-login-email">E-Mail</label>
            <input
              id="am-login-email"
              class="email-input"
              placeholder="name@company.com"
              type="email"
              formControlName="email"
            />
          </div>
          <div class="session_wrapper_2-input">
            <label for="am-login-password">Password</label>
            <input
              id="am-login-password"
              placeholder="Enter your Password"
              [type]="showPassword ? 'text' : 'password'"
              formControlName="password"
            />
            <div
              class="input_eye_icon"
              [ngClass]="{ show: showPassword }"
              (click)="showPassword = !showPassword"
            ></div>
          </div>
        </div>
        <button
          class="login-with_email-button"
          mat-button
          [disabled]="loading"
        >
          <span>{{ loading ? "Signing in..." : "Sign in" }}</span>
        </button>
        <p class="am-auth-error" *ngIf="moreInfo">{{ moreInfo }}</p>
      </div>
      <div class="session_wrapper_2-footer">
        <p class="session_wrapper_2-has-account">
          <span (click)="setView('resetPassword')">Unable to log in?</span>
        </p>
        <p class="session_wrapper_2-has-account">
          Don't have an account?
          <span (click)="setView('signup')">Sign up</span>
        </p>
      </div>
    </form>

    <!-- Signup -->
    <form
      class="session_wrapper_2-content"
      [formGroup]="signupForm"
      (ngSubmit)="signup()"
      *ngIf="view === 'signup'"
    >
      <div class="session_wrapper_2-header">
        <img
          class="am-product-logo"
          src="../../../assets/img/agentic_monitoring_logo.svg"
          alt=""
        />
        <div class="session_wrapper_2-header-text">
          <h1>Sign up for Agentic Monitoring</h1>
        </div>
      </div>
      <div class="session_wrapper_2-body">
        <button
          type="button"
          class="login-with_email-button"
          mat-button
          [disabled]="loading"
          (click)="loginWithGoogle($event, 'agentic-monitoring/setup')"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100"
            height="100"
            viewBox="0 0 48 48"
            aria-hidden="true"
          >
            <path
              fill="#FFC107"
              d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"
            ></path>
            <path
              fill="#FF3D00"
              d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"
            ></path>
            <path
              fill="#4CAF50"
              d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"
            ></path>
            <path
              fill="#1976D2"
              d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"
            ></path>
          </svg>
          <span>Sign up with Google</span>
        </button>
        <div class="session_wrapper_2-body-or" *ngIf="showSignupInputs">
          <p>or</p>
        </div>
        <div
          class="session_wrapper_2-body-inputs-container"
          [class.show-inputs]="showSignupInputs"
        >
          <div class="session_wrapper_2-input">
            <label for="am-signup-name">Full name</label>
            <input
              id="am-signup-name"
              placeholder="Your full name"
              type="text"
              formControlName="fullname"
            />
          </div>
          <div class="session_wrapper_2-input">
            <label for="am-signup-email">E-Mail</label>
            <input
              id="am-signup-email"
              class="email-input"
              placeholder="name@company.com"
              type="email"
              formControlName="email"
            />
          </div>
          <div class="session_wrapper_2-input">
            <label for="am-signup-password">Password</label>
            <input
              id="am-signup-password"
              placeholder="Create a Password"
              [type]="showPassword ? 'text' : 'password'"
              formControlName="password"
            />
            <div
              class="input_eye_icon"
              [ngClass]="{ show: showPassword }"
              (click)="showPassword = !showPassword"
            ></div>
          </div>
        </div>
        <button
          class="login-with_email-button"
          mat-button
          [disabled]="loading"
          (click)="continueSignupWithEmail($event)"
        >
          <span *ngIf="!showSignupInputs">Sign up with Email</span>
          <span *ngIf="showSignupInputs">
            {{ loading ? "Creating account..." : "Create your account" }}
          </span>
        </button>
        <p class="am-auth-error" *ngIf="moreInfo">{{ moreInfo }}</p>
      </div>
      <div class="session_wrapper_2-footer">
        <p class="session_wrapper_2-has-account">
          Already have an account?
          <span (click)="setView('login')">Sign in</span>
        </p>
        <p class="session_wrapper_2-has-account">
          By signing up you accept the content of
          <a
            href="https://behamics.com/legal/privacy-policy-en.pdf"
            target="_blank"
            rel="noopener"
            >Privacy Policy.</a
          >
        </p>
      </div>
    </form>

    <!-- Two-factor -->
    <form
      class="session_wrapper_2-content"
      [formGroup]="twoFactorForm"
      (ngSubmit)="submitTwoFactorCode()"
      *ngIf="view === 'twoFactor'"
    >
      <div class="session_wrapper_2-header">
        <div class="session_wrapper_2-header-text">
          <h1>Two-Step Verification</h1>
          <p>
            We've sent a code to your email. Please enter it below to proceed.
          </p>
        </div>
      </div>
      <div class="session_wrapper_2-body">
        <div class="session_wrapper_2-body-inputs-container show-inputs">
          <div class="session_wrapper_2-input">
            <label for="am-2fa-code">2FA Code</label>
            <input
              id="am-2fa-code"
              placeholder="Enter the 2FA Code"
              type="text"
              formControlName="twoFARequired"
            />
          </div>
        </div>
        <button
          class="login-with_email-button"
          mat-button
          [disabled]="loading || twoFactorForm.invalid"
        >
          <span>Submit</span>
        </button>
        <p class="am-auth-error" *ngIf="moreInfo">{{ moreInfo }}</p>
      </div>
      <div class="session_wrapper_2-footer">
        <p class="session_wrapper_2-has-account">
          <span (click)="setView('login')">Back to Login Page</span>
        </p>
      </div>
    </form>

    <!-- Reset password -->
    <form
      class="session_wrapper_2-content"
      [formGroup]="resetPasswordForm"
      (ngSubmit)="resetPassword()"
      *ngIf="view === 'resetPassword'"
    >
      <div class="session_wrapper_2-header">
        <div class="session_wrapper_2-header-text">
          <h1>Reset your password</h1>
          <p>{{ resetPasswordStatus }}</p>
        </div>
      </div>
      <div class="session_wrapper_2-body">
        <div class="session_wrapper_2-body-inputs-container show-inputs">
          <div class="session_wrapper_2-input">
            <label for="am-reset-email">E-Mail</label>
            <input
              id="am-reset-email"
              class="email-input"
              placeholder="E-Mail"
              type="email"
              formControlName="email"
              [attr.disabled]="resetPasswordFinished || null"
            />
          </div>
        </div>
        <button
          class="login-with_email-button"
          mat-button
          [disabled]="loading || resetPasswordFinished"
        >
          <span>{{ resetPasswordFinished ? "Sent" : "Reset password" }}</span>
        </button>
        <p class="am-auth-error" *ngIf="moreInfo">{{ moreInfo }}</p>
      </div>
      <div class="session_wrapper_2-footer">
        <p class="session_wrapper_2-has-account">
          <span (click)="setView('login')">Back to Login Page</span>
        </p>
      </div>
    </form>
  </div>

  <aside class="session_wrapper_2-right_container am-auth-aside">
    <div class="session_wrapper_2-right_container-header am-aside-header">
      <h1>See every AI agent<br />that visits your site</h1>
      <p>
        Monitor AI crawlers, assistants and shopping agents in real time, and
        decide what they can access.
      </p>
    </div>

    <section class="am-traffic-card" aria-label="Live agent traffic preview">
      <div class="am-traffic-heading">
        <span aria-hidden="true"></span>
        Live agent traffic
      </div>

      <div class="am-traffic-row">
        <span class="am-traffic-avatar">G</span>
        <div class="am-traffic-details">
          <div><strong>GPTBot</strong><span>· Crawler</span></div>
          <code>/products/trail-runner-x2</code>
        </div>
        <span class="am-traffic-status allowed">Allowed</span>
      </div>
      <div class="am-traffic-row">
        <span class="am-traffic-avatar">C</span>
        <div class="am-traffic-details">
          <div><strong>ClaudeBot</strong><span>· Crawler</span></div>
          <code>/blog/sizing-guide</code>
        </div>
        <span class="am-traffic-status allowed">Allowed</span>
      </div>
      <div class="am-traffic-row">
        <span class="am-traffic-avatar">P</span>
        <div class="am-traffic-details">
          <div><strong>PerplexityBot</strong><span>· Crawler</span></div>
          <code>/collections/rain-jackets</code>
        </div>
        <span class="am-traffic-status limited">Training blocked</span>
      </div>
      <div class="am-traffic-row">
        <span class="am-traffic-avatar">S</span>
        <div class="am-traffic-details">
          <div><strong>Shopping agent</strong><span>· Checkout</span></div>
          <code>/cart/checkout</code>
        </div>
        <span class="am-traffic-status allowed">Allowed</span>
      </div>
      <div class="am-traffic-row">
        <span class="am-traffic-avatar">B</span>
        <div class="am-traffic-details">
          <div><strong>Bytespider</strong><span>· Crawler</span></div>
          <code>/collections/sale</code>
        </div>
        <span class="am-traffic-status blocked">Blocked</span>
      </div>
    </section>
  </aside>
</div>
